(() => {
  window.swinger.eventHub.register('click', '.swinger-age_verification', () => {
    window.swinger.cookie.set('ageVerificationPassed', Date.now(), 92 * 24 * 60 * 60);

    window.swinger.$('.swinger-header, main').forEach((elem) => {
      elem.inert = false;
    });
    window.swinger.$('.swinger-header, main, .swinger-header *, main *').forEach((elem) => {
      elem.style.pointerEvents = '';
    });

    window.swinger.overlayManager.close('age-overlay');
  });
  window.swinger.eventHub.register('click', '.swinger-age_decline', () => {
    // leave the site
    window.history.back();
    window.setTimeout(() => {
      window.location.replace('about:blank');
    }, 2000);
  });
})();
